import { render } from "./TardyReportsTable.vue?vue&type=template&id=25485a4b"
import script from "./TardyReportsTable.vue?vue&type=script&lang=js"
export * from "./TardyReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__